/** Application statuses where the candidate is still in the employer pipeline. Keep in sync with api/apps/applications/constants.py ACTIVE_APPLICATION_STATUSES. */
import type { BadgeProps } from '@/components/ui/badge'

export const ACTIVE_APPLICATION_STATUSES = new Set([
  'applied',
  'invited',
  'in_review',
  'interview',
  'offer',
])

export function isActiveApplicationStatus(status: string): boolean {
  return ACTIVE_APPLICATION_STATUSES.has(status)
}

export function formatApplicationStatus(status: string): string {
  return status.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}

type BadgeVariant = NonNullable<BadgeProps['variant']>

/** Soft badge variants for application lifecycle chips on cards and detail. */
export function applicationStatusBadgeVariant(status: string): BadgeVariant {
  switch (status) {
    case 'offer':
    case 'hired':
      return 'successSoft'
    case 'rejected':
      return 'destructiveSoft'
    case 'invited':
    case 'withdrawn':
      return 'secondarySoft'
    case 'applied':
    case 'in_review':
    case 'interview':
      return 'defaultSoft'
    default:
      return 'secondarySoft'
  }
}

export function canReapplyAfterWithdraw(status: string): boolean {
  return status === 'withdrawn'
}

/** Terminal outcomes where the candidate cannot self-serve a new application. */
export function isBlockedApplicationStatus(status: string): boolean {
  return status === 'rejected' || status === 'hired'
}
